
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/sign-up",
      function () {
        return require("private-next-pages/users/sign-up.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/sign-up"])
      });
    }
  